import { css } from "styled-components";
import { Icon } from "../../../../../../components/Icon";
import { riotProductSkin } from "../riot-product";
export const riotLionSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}
  a {
    &.variant-playstation,
    &.variant-xbox {
      color: ${paletteTokens.accents2};
      padding: 16px;
      ${chroma.mediaQueries.mobileDown} {
        padding: 16px;
      }
    }
    ${Icon} {
      background-color: ${paletteTokens.accents2};
    }
  }
`;
//# sourceMappingURL=index.js.map